<div class="block__left-side-panel">
    <h1 class="text-items__title">{{'ISIC_CARD_ACTIVATION_SIDE_TITLE' | translate}}</h1>
    <p class="text-items__description"><span>{{'ISIC_CARD_ACTIVATION_SIDE_DESCRIPTION' | translate}}</span></p>
</div>